import { Navigate, Route, Routes } from 'react-router-dom';
import { RoutePaths } from '@shared/utils';
import {
  // ApplyNowPage,
  LoginPage,
  PasswordResetForm,
  RecoveryPage,
  RecoveryResetPick,
  RecoveryResetUsernameForm,
} from '@pages';

export const Public = () => {
  return (
    <Routes>
      <Route path={RoutePaths.login.path} element={<LoginPage />} />
      {/* <Route path={RoutePaths.applyNow.path} element={<ApplyNowPage />} /> */}
      <Route path={RoutePaths.recovery.path} element={<RecoveryPage />}>
        <Route index element={<RecoveryResetPick />} />
        <Route path={RoutePaths.recoveryUsername.path} element={<RecoveryResetUsernameForm />} />
        <Route path={RoutePaths.recoveryPassword.path} element={<PasswordResetForm />} />
      </Route>
      <Route path='*' element={<Navigate to={RoutePaths.login.onNavigate()} />} />
    </Routes>
  );
};
